import { useEffect, useState } from "react";
import axiosInstance from "config/axiosInstance";
import Table from "examples/Tables/Table";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import Card from "@mui/material/Card";
import Chip from "@mui/material/Chip";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { formatDateTimePeru } from "utils/datePeru";
import { formatDisplayPhone } from "./NotificationRecipientsSummary";
import { getStatusUi } from "utils/whatsappUi";
import { WA_TABS_SX } from "./WaOutlineButton";

export default function LogsPanel({ refreshKey = 0 }) {
  const [tab, setTab] = useState("all");
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let active = true;
    const load = async () => {
      setLoading(true);
      try {
        const params = { limit: 50 };
        if (tab === "enviado" || tab === "error") {
          params.estado = tab;
        }
        const res = await axiosInstance.get("/whatsapp/logs", { params });
        if (active && res.data.success) {
          setLogs(res.data.logs || []);
        }
      } catch {
        if (active) setLogs([]);
      } finally {
        if (active) setLoading(false);
      }
    };
    load();
    return () => {
      active = false;
    };
  }, [tab, refreshKey]);

  const rows = logs.map((log) => {
    const ui = getStatusUi(log.estado === "enviado" ? "enviado" : "error");
    return {
      telefono: formatDisplayPhone(log.telefono_destino),
      estado: (
        <Chip
          label={`${ui.emoji} ${ui.label}`}
          size="small"
          color={ui.color}
        />
      ),
      deposito: log.deposito_id ?? "—",
      fecha: formatDateTimePeru(log.created_at),
    };
  });

  return (
    <VuiBox>
      <VuiTypography variant="h5" color="white" fontWeight="bold" mb={0.5}>
        Logs de envío
      </VuiTypography>
      <VuiTypography variant="button" color="text" mb={2} display="block">
        Registro de envíos completados
      </VuiTypography>

      <Tabs
        value={tab}
        onChange={(_, value) => setTab(value)}
        variant="fullWidth"
        sx={{ ...WA_TABS_SX, mb: 2 }}
      >
        <Tab label="Todos" value="all" />
        <Tab label="Enviados" value="enviado" />
        <Tab label="Errores" value="error" />
      </Tabs>

      <Card>
        <VuiBox sx={{ overflowX: "auto" }}>
          <Table
            brightHeader
            columns={[
              { name: "telefono", label: "Teléfono", align: "left" },
              { name: "estado", label: "Estado", align: "center" },
              { name: "deposito", label: "Depósito", align: "center" },
              { name: "fecha", label: "Fecha", align: "right" },
            ]}
            rows={rows}
          />
          {!loading && rows.length === 0 && (
            <VuiBox py={4} textAlign="center">
              <VuiTypography variant="button" color="text">
                Sin registros para este filtro
              </VuiTypography>
            </VuiBox>
          )}
        </VuiBox>
      </Card>
    </VuiBox>
  );
}
